import { factoryService, postJsonRequest, putJsonRequest } from '@chilecompra/react-kit/requests'
import { REACT_APP_API_BASE_BUYER_URL } from '../config/settings/environment'

/**
 * Send validation code to email
 */
export const sendValidationEmail = factoryService(({ dni, email, name, motherLastName, fatherLastName, flowId }) => {
  const body = {
    rut: dni,
    email,
    nombre: name,
    apellidoMaterno: motherLastName,
    apellidoPaterno: fatherLastName,
    idFlujo: flowId
  }
  return postJsonRequest(`${REACT_APP_API_BASE_BUYER_URL}/v1/compradores/correoVerificacion/enviar`, { body })
})

/**
 * Validate the code sent to the user's email.
 */
export const codeValidation = factoryService(({ code, email, flowId, id }) => {
  const body = {
    codigo: code,
    email,
    idFlujo: flowId,
    idPersona: id
  }
  return putJsonRequest(`${REACT_APP_API_BASE_BUYER_URL}/v1/compradores/codigoVerificacion/validar`, { body })
})

/**
 * Send receipt code to email
 */
export const sendReceiptEmail = factoryService(({ dni, email, name, motherLastName, fatherLastName, requestCode }) => {
  const body = {
    dni,
    email,
    nombre: name,
    apellidoMaterno: motherLastName,
    apellidoPaterno: fatherLastName,
    requestCode
  }
  return postJsonRequest(`${REACT_APP_API_BASE_BUYER_URL}/v1/compradores/correoComprobante/enviar`, { body })
})
